import { render, staticRenderFns } from "./transactionComponent.vue?vue&type=template&id=bfb86338&scoped=true&"
import script from "./transactionComponent.vue?vue&type=script&lang=js&"
export * from "./transactionComponent.vue?vue&type=script&lang=js&"
import style0 from "./transactionComponent.vue?vue&type=style&index=0&id=bfb86338&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb86338",
  null
  
)

export default component.exports